<template>
    <div />
</template>

<script>
import { auth } from '@/auth'
import { parseQuery } from './Session/functions'

export default {
    name: 'session',
    beforeMount() {
        const queryStr = window.location.hash.substr(1)
        const query = parseQuery(queryStr)
        auth.setToken(query)
        this.$router.replace({ name: 'dashboard' })
    },
}
</script>
